export default {"src":"/_next/static/media/China.b3aa5c57.svg","height":401,"width":320,"blurWidth":0,"blurHeight":0};